<template>
  <v-app>
    <v-content style="background:#fff">
      <v-container fluid class="pa-0">
        <v-layout justify-center>
          <v-flex xs12 sm10 md8 lg6>
            <v-card flat class="pa-4 mt-4">

              <div class="text-xs-center mb-4">
                <img src="/img/swv-wien-logo.svg" alt="SWV Wien" style="max-height: 120px; max-width: 80%">
              </div>

              <h1 class="headline font-weight-bold mb-3">Datenschutzerklärung</h1>

              <h2 class="title mt-4 mb-2">Verantwortlicher</h2>
              <p>
                SWV-Alsergrund<br>
                Eric Rubas, Obmann<br>
                1090 Wien<br>
                E-Mail: eric@rubas.at<br>
                Telefon: 0664 230 40 42
              </p>

              <h2 class="title mt-4 mb-2">Erhobene Daten</h2>
              <p>
                Im Rahmen der Anmeldung zu Veranstaltungen des SWV-Alsergrund
                können folgende personenbezogene Daten erhoben werden:
              </p>
              <ul class="mb-3">
                <li>Name</li>
                <li>E-Mail-Adresse</li>
                <li>Telefonnummer</li>
                <li>Weitere freiwillige Angaben im Zusammenhang mit der jeweiligen Veranstaltung</li>
              </ul>

              <h2 class="title mt-4 mb-2">Zweck der Verarbeitung</h2>
              <p>
                Ihre Daten werden ausschließlich für folgende Zwecke verwendet:
              </p>
              <ul class="mb-3">
                <li>Organisation und Durchführung von Veranstaltungen des SWV-Alsergrund</li>
                <li>Kontaktaufnahme im Zusammenhang mit den Veranstaltungen</li>
                <li>Auf Ihren Wunsch: Zusendung von Einladungen zu künftigen Veranstaltungen</li>
              </ul>

              <h2 class="title mt-4 mb-2">Rechtsgrundlage</h2>
              <p>
                Die Verarbeitung erfolgt auf Grundlage Ihrer Einwilligung gemäß
                Art. 6 Abs. 1 lit. a DSGVO. Sie können Ihre Einwilligung jederzeit
                mit Wirkung für die Zukunft widerrufen.
              </p>

              <h2 class="title mt-4 mb-2">Auftragsverarbeiter</h2>
              <p>
                Für den Versand von Benachrichtigungen wird der Dienst Brevo (Sendinblue GmbH,
                Köpenicker Straße 126, 10179 Berlin, Deutschland) als Auftragsverarbeiter eingesetzt.
                Die Datenverarbeitung erfolgt auf Servern innerhalb der Europäischen Union.
              </p>

              <h2 class="title mt-4 mb-2">Speicherdauer</h2>
              <p>
                Ihre Daten werden nach Durchführung der jeweiligen Veranstaltung gelöscht,
                sofern Sie nicht der Zusendung künftiger Einladungen zugestimmt haben.
                In diesem Fall werden Ihre Daten bis zum Widerruf Ihrer Einwilligung gespeichert.
              </p>

              <h2 class="title mt-4 mb-2">Ihre Rechte</h2>
              <p>Sie haben das Recht auf:</p>
              <ul class="mb-3">
                <li>Auskunft über Ihre gespeicherten Daten (Art. 15 DSGVO)</li>
                <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
                <li>Löschung Ihrer Daten (Art. 17 DSGVO)</li>
                <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
                <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
                <li>Widerruf Ihrer Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
                <li>Beschwerde bei der Datenschutzbehörde (dsb.gv.at)</li>
              </ul>

              <h2 class="title mt-4 mb-2">Kontakt</h2>
              <p>
                Bei Fragen zum Datenschutz wenden Sie sich bitte an:<br>
                Eric Rubas, eric@rubas.at, 0664 230 40 42
              </p>

              <v-divider class="mt-4 mb-3" />

              <div class="text-xs-center">
                <router-link :to="{name: 'SwvFruehstueck2026'}">
                  Zurück zur Anmeldung
                </router-link>
              </div>

            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {};
</script>
